import { FilterMode } from '../constants';

import { CODE_SEARCH_CHANGE, FilterFiles, FILTER_MODE_CHANGE } from './';

export const filterFiles = (query: string) => ({
  type: FilterFiles.REQUEST,
  payload: query,
});

export const onFilterModeChange = (payload: FilterMode) => ({
  type: FILTER_MODE_CHANGE,
  payload,
});

export const onCodeSearchChange = (query: string) => ({
  type: CODE_SEARCH_CHANGE,
  payload: query,
});
